import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const CommunicationPanel = ({ owner }) => {
  const [message, setMessage] = useState('');
  const [activeTab, setActiveTab] = useState('whatsapp');

  const communicationHistory = [
    {
      id: 1,
      type: 'whatsapp',
      message: 'تم إرسال تقرير الإيرادات الشهري',
      timestamp: '2026-01-10 14:30',
      status: 'تم التسليم',
    },
    {
      id: 2,
      type: 'phone',
      message: 'مكالمة هاتفية - مناقشة صيانة العقار',
      timestamp: '2026-01-09 11:15',
      status: 'مكتمل',
    },
    {
      id: 3,
      type: 'email',
      message: 'إرسال نسخة من العقد المحدث',
      timestamp: '2026-01-08 09:45',
      status: 'تم القراءة',
    },
    {
      id: 4,
      type: 'whatsapp',
      message: 'تذكير بموعد الصيانة الدورية',
      timestamp: '2026-01-07 16:20',
      status: 'تم التسليم',
    },
  ];

  const handleSendMessage = () => {
    if (message?.trim()) {
      console.log('Sending message:', message);
      setMessage('');
    }
  };

  const getTypeIcon = (type) => {
    switch (type) {
      case 'whatsapp':
        return 'MessageSquare';
      case 'phone':
        return 'Phone';
      case 'email':
        return 'Mail';
      default:
        return 'MessageCircle';
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'تم التسليم':
        return 'text-success';
      case 'تم القراءة':
        return 'text-primary';
      case 'مكتمل':
        return 'text-success';
      default:
        return 'text-muted-foreground';
    }
  };

  if (!owner) {
    return (
      <div className="bg-black rounded-lg border border-primary/30 p-6 text-center">
        <Icon name="MessageCircleOff" size={40} color="var(--color-muted-foreground)" />
        <p className="text-muted-foreground mt-3 text-sm">
          اختر مالكاً لبدء التواصل
        </p>
      </div>
    );
  }

  return (
    <div className="bg-black rounded-lg border border-primary/30 overflow-hidden h-full flex flex-col">
      <div className="p-4 border-b border-primary/30">
        <div className="flex items-center justify-center gap-2 mb-3 px-4 py-3 rounded-xl border-2 shadow-warm-sm" style={{
          background: 'linear-gradient(135deg, rgba(245, 158, 11, 0.15) 0%, rgba(251, 191, 36, 0.15) 100%)',
          borderColor: 'rgba(245, 158, 11, 0.4)'
        }}>
          <Icon name="MessageCircle" size={20} color="#F59E0B" />
          <h3 className="font-heading font-bold text-sm md:text-base" style={{
            background: 'linear-gradient(135deg, #F59E0B 0%, #FBBF24 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text'
          }}>
            أدوات التواصل
          </h3>
        </div>

        <div className="flex gap-2 overflow-x-auto">
          <Button
            variant={activeTab === 'whatsapp' ? 'default' : 'outline'}
            size="sm"
            iconName="MessageSquare"
            iconSize={16}
            onClick={() => setActiveTab('whatsapp')}
          >
            واتساب
          </Button>
          <Button
            variant={activeTab === 'phone' ? 'default' : 'outline'}
            size="sm"
            iconName="Phone"
            iconSize={16}
            onClick={() => setActiveTab('phone')}
          >
            اتصال
          </Button>
          <Button
            variant={activeTab === 'email' ? 'default' : 'outline'}
            size="sm"
            iconName="Mail"
            iconSize={16}
            onClick={() => setActiveTab('email')}
          >
            بريد
          </Button>
        </div>
      </div>
      <div className="flex-1 overflow-y-auto p-4">
        <h4 className="font-caption font-medium text-muted-foreground text-xs mb-3">
          سجل التواصل
        </h4>
        <div className="space-y-3">
          {communicationHistory?.map((item) => (
            <div
              key={item?.id}
              className="p-3 rounded-lg bg-muted/50 border border-border hover:bg-muted transition-colors"
            >
              <div className="flex items-start gap-2 mb-2">
                <Icon
                  name={getTypeIcon(item?.type)}
                  size={16}
                  color="var(--color-primary)"
                />
                <div className="flex-1 min-w-0">
                  <p className="text-sm text-foreground line-clamp-2">
                    {item?.message}
                  </p>
                </div>
              </div>
              <div className="flex items-center justify-between text-xs">
                <span className="font-data text-muted-foreground">
                  {item?.timestamp}
                </span>
                <span className={`font-caption ${getStatusColor(item?.status)}`}>
                  {item?.status}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="p-4 border-t border-primary/30">
        <div className="flex gap-2">
          <Input
            type="text"
            placeholder="اكتب رسالة..."
            value={message}
            onChange={(e) => setMessage(e?.target?.value)}
            onKeyPress={(e) => e?.key === 'Enter' && handleSendMessage()}
            className="flex-1"
          />
          <Button
            variant="default"
            size="icon"
            iconName="Send"
            iconSize={18}
            onClick={handleSendMessage}
            disabled={!message?.trim()}
          />
        </div>
      </div>
    </div>
  );
};

export default CommunicationPanel;